import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { MdKeyboardArrowDown } from "react-icons/md";
import { motion, useAnimation, useInView } from "framer-motion";
import { useTranslation } from "react-i18next";

const FAQ = () => {
  const [activeAnswer, setActiveAnswer] = useState(null);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animation1 = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation1.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);
  const { t } = useTranslation();

  return (
    <Container>
      <div className="title">
        <h1>FAQ</h1>
        <p>
          {t("faqs")}{" "}
          <Link to={"/contact-us"} className="link-styles">
            Contact Us
          </Link>
        </p>
      </div>
      <div ref={ref} className="questions">
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 0.3, type: "spring" }}
          className={activeAnswer === 1 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 1 ? null : 1)}
        >
          <span>
            <h2>{t("Q1")}</h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>{t("A1")}</p>
        </motion.div>
        <hr />
        {/* <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 0.5, type: "spring" }}
          className={activeAnswer === 2 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 2 ? null : 2)}
        >
          <span>
            <h2>Can you print custom photos?</h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>
            Yes, I do. You can go to Custom Print ,and upload your own photo to
            print.
          </p>
        </motion.div>
        <hr /> */}
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 0.7, type: "spring" }}
          className={activeAnswer === 3 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 3 ? null : 3)}
        >
          <span>
            <h2>{t("Q2")}</h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>{t("A2")}</p>
        </motion.div>
        <hr />
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 0.9, type: "spring" }}
          className={activeAnswer === 4 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 4 ? null : 4)}
        >
          <span>
            <h2>{t("Q3")}</h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>{t("A3")}</p>
        </motion.div>
        <hr />
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
          initial="hidden"
          animate={animation1}
          transition={{ duration: 0.4, delay: 1.1, type: "spring" }}
          className={activeAnswer === 5 ? "active" : "row"}
          onClick={() => setActiveAnswer(activeAnswer === 5 ? null : 5)}
        >
          <span>
            <h2>{t("Q4")}</h2>
            <MdKeyboardArrowDown className="icon" />
          </span>
          <p>{t("A4")}</p>
        </motion.div>
      </div>
    </Container>
  );
};
const Container = styled.div`
  padding: 7em 4%;
  background-image: var(--bgGradient4);
  .title {
    text-align: center;
    h1 {
      font-weight: 200;
      font-size: 4.7em;
      -webkit-text-fill-color: transparent;
      background-image: linear-gradient(
        67deg,
        var(--fontPrimaryColor) 33%,
        var(--primaryBackgroundColor) 77%
      );
      -webkit-background-clip: text;
      background-clip: text;
    }
    p {
      width: 60%;
      margin: auto;
      margin-top: 1em;
      color: var(--fontSecondaryColor);
      font-weight: 300;
    }
  }
  .questions {
    transition: 0.4s;
    display: flex;
    flex-direction: column;
    gap: 1em;
    margin: 2em 0;
    align-items: center;
    hr {
      width: 80%;
      border: none;
      border-top: 1px solid var(--fontSecondaryColor);
    }
    .row {
      transition: 0.4s;
      height: 30px;
      width: 80%;
      cursor: pointer;
      span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h2 {
          color: var(--fontPrimaryColor);
          font-weight: 500;
          font-size: 18px;
        }
        .icon {
          font-size: 2em;
          color: var(--fontPrimaryColor);
        }
      }
      p {
        display: none;
      }
    }

    .active {
      transition: 0.4s;
      height: 50px;
      width: 80%;
      cursor: pointer;
      p {
        transition: 0.4s;
        display: flex;
        color: var(--fontSecondaryColor);
        font-weight: 300;
      }
      span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h2 {
          color: var(--fontPrimaryColor);
          font-weight: 500;
          font-size: 20px;
          transition: 0.4s;
        }
        .icon {
          transform: rotate(180deg);
          font-size: 2em;
          color: var(--primaryColor);
        }
      }
    }
  }
  @media (min-width: 2050px) {
    height: 40vh;
  }
  @media (max-width: 1170px) {
    .questions {
      hr {
        width: 97%;
      }
      .row {
        width: 98%;
      }
      .active {
        width: 98%;
      }
    }
  }
  /* @media (max-width: 955px) {
    .questions {
      .row {
        h2 {
          font-size: 1.4em;
        }
      }
      .active {
        width: 98%;
        height: 40px;
        h2 {
          font-size: 1.4em;
        }
        p {
          line-height: 20px;
        }
      }
    }
  } */
  @media (max-width: 870px) {
    .questions {
      .active {
        height: 47px;
      }
    }
  }
  @media (max-width: 730px) {
    .questions {
      .active {
        height: 60px;
      }
    }
  }
  @media (max-width: 500px) {
    .questions {
      .row {
        height: 40px;
        h2 {
          font-size: 1.2em;
        }
      }
      .active {
        h2 {
          font-size: 1.2em;
        }
        p {
          font-size: 15px;
        }
      }
    }
  }
  @media (max-width: 450px) {
    .questions {
      .active {
        height: 80px;
        h2 {
          font-size: 1.2em;
        }
        p {
          font-size: 15px;
        }
      }
    }
  }
  @media (max-width: 450px) {
    .questions {
      .active {
        height: 90px;
        h2 {
          font-size: 1.2em;
        }
        p {
          font-size: 15px;
        }
      }
    }
  }
`;

export default FAQ;
